import type { User } from '@/auth/types';

/**
 * Suggest a friendly default project name from the signed-in user (FE `useAuth`).
 * Prefers the display name, falls back to the email's local-part, then a generic
 * label. The user can always edit or clear it in the dialog.
 *   { name: "Linh Tran" }            → "Linh Tran's monitoring"
 *   { email: "ops@acme.com" }        → "ops's monitoring"
 *   {}                               → "My monitoring project"
 */
export function suggestProjectName(user: User | null): string {
  const fromName = user?.name?.trim();
  if (fromName) return `${fromName}'s monitoring`;

  const local = user?.email?.split('@')[0]?.trim();
  if (local) return `${local}'s monitoring`;

  return 'My monitoring project';
}
